import './timer.scss';

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  timerStarted: boolean;
  onRetry: () => void;
}

const Timer: React.FC<IProps> = ({ timerStarted, onRetry }) => {
  const { t } = useTranslation();
  const interval = useRef<ReturnType<typeof setInterval> | undefined>(
    undefined
  );
  const [timer, setTimer] = useState(59);
  const [canStartTimer, setCanStartTimer] = useState(true);

  const timeoutBody = useCallback(() => {
    if (timer > 0) setTimer((prevState) => prevState - 1);
    else clearInterval(interval.current);
  }, [timer]);

  const handleRetry = () => {
    setTimer(59);
    onRetry();
    setCanStartTimer(true);
  };

  useEffect(() => {
    if (timerStarted) interval.current = setInterval(timeoutBody, 1000);
    return () => {
      clearInterval(interval.current);
    };
  }, [timerStarted, timer, timeoutBody]);

  return (
    <>
      {timer === 0 || !canStartTimer ? (
        <button type="button" className="timer__button" onClick={handleRetry}>
          {t('resend_code')}
        </button>
      ) : (
        <span className="timer__seconds">
          {t('resend_code_in')} {`00:${timer > 9 ? timer : `0${timer}`}`}
        </span>
      )}
    </>
  );
};

export default Timer;
